import ContainerFluidComponent from './ContainerFluid'
import ContainerComponent from './Container'
import RowComponent from './Row'
import ColComponent from './Col'
import ClearfixComponent from './Clearfix'
import HiddenComponent from './Hidden'
import AlignSMComponent from './AlignSM'
import AlignComponent from './Align'
import ResponsiveEmbedComponent from './ResponsiveEmbed'

export const ContainerFluid = ContainerFluidComponent
export const Container = ContainerComponent
export const Row = RowComponent
export const Col = ColComponent
export const Hidden = HiddenComponent
export const AlignSM = AlignSMComponent
export const Align = AlignComponent
export const Clearfix = ClearfixComponent
export const ResponsiveEmbed = ResponsiveEmbedComponent



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Grid/index.js